/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Feedback_CreateInputs */

const es_tools_nexata_feedback_create = /** @type {(inputs: Tools_Nexata_Feedback_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrando feedback...`)
};

const en_tools_nexata_feedback_create = /** @type {(inputs: Tools_Nexata_Feedback_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving feedback...`)
};

/**
* | output |
* | --- |
* | "Saving feedback..." |
*
* @param {Tools_Nexata_Feedback_CreateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_feedback_create = /** @type {((inputs?: Tools_Nexata_Feedback_CreateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Feedback_CreateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_feedback_create(inputs)
	return en_tools_nexata_feedback_create(inputs)
});
export { tools_nexata_feedback_create as "tools.nexata.feedback_create" }